import { ReactNode } from 'react';
import Dialog from '@mui/material/Dialog';
import { DeleteOutline } from '@mui/icons-material';
import styled from '@emotion/styled';
import { settingsTheme as t } from '../../theme';
import Button from './Button';

interface DeleteConfirmDialogProps {
  open: boolean;
  title: string;
  description: ReactNode;
  cancelLabel: string;
  confirmLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const Content = styled.div({ padding: 28 });

const IconCircle = styled.div({
  width: 52,
  height: 52,
  borderRadius: '50%',
  background: t.color.dangerSurface,
  color: t.color.danger,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 16,
  '& .MuiSvgIcon-root': { fontSize: 27 },
});

const Title = styled.div({
  fontFamily: t.font,
  fontSize: 18,
  fontWeight: 600,
  color: t.color.title,
});

const Description = styled.p({
  margin: '8px 0 0',
  fontFamily: t.font,
  fontSize: 14,
  lineHeight: 1.55,
  color: t.color.muted,
});

const Actions = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 12,
  marginTop: 24,
});

/**
 * Organismo: diálogo de confirmación destructiva. Visualmente alineado con la
 * tabla (icono rojo, acción primaria en rojo) y accesible vía MUI Dialog.
 */
const DeleteConfirmDialog = ({
  open,
  title,
  description,
  cancelLabel,
  confirmLabel,
  onCancel,
  onConfirm,
}: DeleteConfirmDialogProps) => (
  <Dialog
    open={open}
    onClose={onCancel}
    PaperProps={{
      sx: { width: 400, maxWidth: '92vw', borderRadius: '16px', boxShadow: '0 20px 50px rgba(16, 24, 40, 0.25)' },
    }}
  >
    <Content>
      <IconCircle>
        <DeleteOutline />
      </IconCircle>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <Actions>
        <Button type="button" variant="secondary" onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button type="button" variant="danger" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </Actions>
    </Content>
  </Dialog>
);

export default DeleteConfirmDialog;
